import type { Category } from "@/constants/categories";

type PersonalCareProduct = {
  id: string;
  name: string;
  categorySlug: Category["slug"];
  brand: string;
  price: number;
  unit: string;
  image: string;
};

const IMG = {
  personal:
    "https://images.unsplash.com/photo-1556228720-195a672e8a03?crop=entropy&cs=srgb&fm=jpg&q=85",
};

const item = (
  id: string,
  name: string,
  brand: string,
  unit: string,
  price: number,
): PersonalCareProduct => ({
  id,
  name,
  categorySlug: "personal-care",
  brand,
  unit,
  price,
  image: IMG.personal,
});

export const PERSONAL_CARE_PRODUCTS: PersonalCareProduct[] = [
  item("pc-dove-delicious-care", "Dove Delicious Care Soap", "Dove", "135g", 3.49),
  item("pc-dove-hidratacion-fresca", "Dove Hidratacion Fresca Soap", "Dove", "135g", 3.49),
  item("pc-dove-original", "Dove Original Soap", "Dove", "135g", 3.49),
  item("pc-dove-purely-pampering", "Dove Purely Pampering Soap", "Dove", "135g", 3.49),
];
